import React from "react";
import "./NewsCard.css";

const NewsCard5 = () => {
  const handleSourceClick = () => {
    window.open("https://www.graphic.com.gh/business/business-news/insurance-industry-urged-to-support-development-of-actuarial-science-professionals.html", "_blank");
  };

  return (
    <div>
    <section className="section-council">
    <div className="sectiontop-line"></div>
    <h2 className="sectiontitle">LATEST NEWS</h2>
    <div className="sectionbottom-line"></div>
    </section>
    <h2 className="newstoptitle">
    Insurance industry urged to support development of actuarial science professionals
    </h2>
    <div className="newscard">
    
      <img
        src="images\News\news2.jpg" 
        alt="News"
        className="newsimage"
      />

     
      <h3 className="newstitle">
      Insurance industry urged to support development of actuarial science professionals
      </h3>

     
      <div className="newsmeta">
        <span className="newssource">
          Source:{" "}
          <button onClick={handleSourceClick} className="sourcelink">
          www.graphic.com
          </button>
        </span>
        <span className="newsdate">15 May 2023</span>
      </div>

      
      <p className="newsdescription">
        In a speech read on his behalf of the launch of the joint education programme by the 
        Actuarial Society of Ghana (ASG) and the Actuarial Society of South Africa (ASSA), 
        the Commissioner of Insurance, Professor Justice Ofori, said without actuarial science professionals, 
        the industry would find it tough to effectively meet the demands of customers.
        <br />
        <br />
        He therefore commended the ASG and the ASSA for this joint education programme, 
        which he believes had taken too long in coming
        <br />
        <br />
        He said the theme for the programme “Developing the next generation of actuaries in Africa” 
        resonates with the NIC’s desire to have a lot more home grown actuarial professionals for the industry.
        <br />
        <br />
        This programme will ultimately help our continent to manage its ever present needs in the industry 
        and the NIC is pleased and wish this had come earlier,” he stated.
        <br />
        <br />
        He said the key role that actuaries play in the global insurance space could not be understated, 
        as they are able to take a peek into the future through the eyes of accurate data.
        <br />
        <br />
        Prof Ofori said actuaries also helped with the roll out of innovative products, adequate pricing and product development.
        <br />
        <br />
        The President of ASG, Neil N.A Tagoe, for his part, said it took 25 years for the ASG to be finally able to roll out this initiative.
        <br />
        <br />
        He said the launch of this programme would go a long way in helping the ASG to meet carry out its mandate effectively.
        <br />
        <br />
        We have a mandate to partner and advise the government on sustainability of existing and development of new social 
        intervention programmes, continue public interest role in financial inclusion with focus on micro insurance and informal sector pensions.
        <br />
        <br />
        But regardless of how nice or intriguing our mandate and strategy may sound, it will difficult to explore them 
        fully in our current state as an industry, with most of our qualified members working outside Ghana and only a 
        handful or limited qualified members practicing here,” he pointed out.
        <br />
        <br />
        He said the a localised pathway to qualification with international repute and local market relevance was needful 
        in dealing with the myriad of challenges the association may encounter in achieving its mandate and strategic focus.
        <br />
        <br />
        The launch of the programme is a step to customise actuarial education to our market and yet not compromise 
        international standards, a step beyond the confines of the challenges we face in educating the next generation 
        of actuaries Africa, a step to resource our non-existent health and general insurance actuarial practice and a 
        step to boost the capacity of our life and pensions industry,” he stated.
        <br />
        <br />
        He said it also represented a step to dare into the wonder world of the wider fields of banking 
        and data science with the qualified actuarial skill set.
        <br />
        <br />
        The Director of the Ghana Insurance College also emphasised the need for a generation of actuarial 
        science professionals who understand Africa’s market dynamics and are able to deal with its economic challenges head on..
        <br />
        <br />
        He said the GIC was optimistic that the collaboration between the ASG and ASSA would further improve 
        its credits and recognition as one the major institutions on the continent.
        <br />
        <br />
        We will support and contribute immensely to ensure that we develop the right caliber and fit for 
        purpose actuaries with the right quality and expertise to man our financial services industry,” he said.
      </p>
    </div>
    </div>
  );
};

export default NewsCard5;
